
export const url = 'https://api.thecatapi.com/v1/images/search?api_key=live_pOFPJfzT1D9jF6kJJ9hHDpSamT47dwUErbeIyDIzJgKQYAHq31JVVhyTWluoXfX6'


export const limiturl = 'https://api.thecatapi.com/v1/images/search?limit='

